export default {
  id: '3c4ca0a490',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div id=app><!-- Views/Tabs container --><!-- Trick per impostare la larghezza massima nei dispositivi desktop --><div class="views tabs safe-areas"><!-- Tabbar for switching views-tabs --><div style="display: none;" class="toolbar toolbar-bottom tabbar-labels"><div id=main-toolbar style=background:white class=toolbar-inner><!--\r\n          <a id="tab-stripe" href="#view-stripe" class="tab-link">\r\n            <img height=\'25px\' src=\'./static/images/cart.png\'/>\r\n            <span class="tabbar-label" style="font-weight: bold; font-size: 1.2em;">Stripe</span>\r\n          </a>\r\n          --><!--\r\n          <a id="tab-checkout" href="#view-checkout" class="tab-link">\r\n            <img height=\'25px\' src=\'./static/images/cart.png\'/>\r\n            <span class="tabbar-label" style="font-weight: bold; font-size: 1.2em;">Checkout</span>\r\n          </a>\r\n          --><!--\r\n          <a id="tab-product-cart-details" href="#view-product-cart-details" class="tab-link">\r\n            <img height=\'25px\' src=\'./static/images/cart.png\'/>\r\n            <span class="tabbar-label" style="font-weight: bold; font-size: 1.2em;">Varianti</span>\r\n          </a>\r\n          --><!--\r\n          <a id="tab-login" href="#view-login" class="tab-link tab-link-active">\r\n            <img height=\'25px\' src=\'./static/images/home.png\'/>\r\n            <span class="tabbar-label" style="font-weight: bold; font-size: 1.2em;">Login</span>\r\n          </a>\r\n          --> <a id=tab-home href=#view-home class="tab-link tab-link-active"><img height=25px src=./static/images/home.png class=tab-image> <img height=25px src=./static/images/homeSelected.png class=tab-image-selected> <span class=tabbar-label style="font-weight: bold; font-size: 1.2em;">Home</span> </a><!--<a id="tab-current-orders" href="#view-current-orders" class="tab-link">\r\n            <img height=\'25px\' src=\'./static/images/cart.png\'/>\r\n            <span class="tabbar-label" style="font-weight: bold; font-size: 1.2em;">Ordine</span>\r\n          </a> --> <a id=tab-profile href=#view-profile class=tab-link><img height=25px src=./static/images/profile.png class=tab-image> <img height=25px src=./static/images/profileSelected.png class=tab-image-selected> <span class=tabbar-label style="font-weight: bold; font-size: 1.2em;">Profilo</span></a></div></div><!-- Login view --><div id=view-login class="view view-main tab" data-name=login data-url=/login/ ></div><!-- Home view --><div id=view-home class="view view-init tab tab-active" data-name=home data-url=/current-position-address/ ></div><!-- Current orders view --><div id=view-current-orders class="view view-init tab" data-name=current-orders data-url=/current-orders/ ></div><!-- Profile view --><div id=view-profile class="view view-init tab" data-name=profile data-url=/profile/ ></div><!-- Product cart details view --><!--\r\n      <div id="view-product-cart-details" class="view view-init tab" data-name="product-cart-details" data-url="/restaurants-products/?id=13">\r\n      </div>\r\n      --><!-- Checkout view --><!--\r\n      <div id="view-checkout" class="view view-init tab" data-name="checkout" data-url="/checkout/">\r\n      </div>\r\n      --><!-- Stripe view --><!--\r\n      <div id="view-stripe" class="view view-init tab" data-name="stripe" data-url="/stripe-payment/">\r\n      </div>\r\n      --></div></div>';
      return r;
    }(this);
  },

  style: `
/* 
Fix "elastic scrolling" su iOS 

https://www.bram.us/2016/05/02/prevent-overscroll-bounce-in-ios-mobilesafari-pure-css/#:~:text=Prevent%20overscroll%2Fbounce%20in%20iOS%20MobileSafari%20and%20Chrome%20(CSS%20only),-Bramus!&text=UPDATE%202017.12%3A%20For%20non%2DSafari,and%20be%20done%20with%20it.
*/

html,
body 
{
  overflow: hidden;
}

#app
{
  background-color: #f6f6f6; 
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}

.toolbar
{
  margin-bottom: env(safe-area-inset-bottom);
  
}


`,
  styleScoped: false
};